/**
 * Leaf helper for grouping bedbank checkout items that share an enquiry session.
 * Kept out of CheckoutActions so user-cart session refresh can group items
 * without the CheckoutActions ↔ userCart cycle.
 */
export function getBedbankSessionGroupingKey(item: App.Checkout.BedbankHotelItem) {
  // If this bedbank rate is part of an accommodation service bundle, we want it to have its own
  // session and _not_ be potentially grouped with other rates.
  if (item.isAccomBundle) return item.itemId
  return `${item.offerId};${item.roomId};${item.roomRateId};${item.checkIn};${item.checkOut}`
}
